import { createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from '@/store';
import { negociacaoColunasService } from './services';
import type { ColunaDisponivel } from '../types';

const getErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : 'Erro desconhecido';

export const fetchColunasDisponiveis = createAsyncThunk<
  ColunaDisponivel[],
  string,
  { rejectValue: string; state: RootState }
>('negociacaoColunas/fetchDisponiveis', async (_escritorioId, { rejectWithValue }) => {
  try {
    return await negociacaoColunasService.listDisponiveis();
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});

export const fetchColunasPreferencia = createAsyncThunk<
  string[],
  string,
  { rejectValue: string; state: RootState }
>('negociacaoColunas/fetchPreferencia', async (_escritorioId, { rejectWithValue }) => {
  try {
    const result = await negociacaoColunasService.getPreferencia();
    return result.fieldIds;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});

export const saveColunasPreferencia = createAsyncThunk<
  string[],
  string[],
  { rejectValue: string; state: RootState }
>('negociacaoColunas/savePreferencia', async (fieldIds, { rejectWithValue }) => {
  try {
    const result = await negociacaoColunasService.putPreferencia(fieldIds);
    return result.fieldIds;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});
